import React from 'react';

import styled from 'styled-components';

const NavigationBar = styled.div`
  width: 100%;
  background: #f2f5f8;
`;

const Container = styled.div`
  max-width: 1200px;
  padding: 0 16px;
`;

const TabPanel = styled.div`
  display: flex;
  align-items: center;
  min-height: 48px;
  gap: 24px;
`;

const TabButton = styled.button`
  padding: 24px 30px;
  color: ${(props) => (props.isActive ? '#33d6d4' : '#363636')};
  background: none;
  border: none;
  font-family: inherit;
  font-size: 14px;
  font-weight: 500;
  position: relative;
  transition: all 0.4s ease-in-out;
  cursor: pointer;
  height: 100%;
  min-height: 48px;
  text-transform: uppercase;
  font-style: normal;
  line-height: 114.286%;
  letter-spacing: 1.25px;
  display: inline-block;

  &:hover {
    background: rgba(0, 0, 0, 0.04);
  }

  ${(props) =>
    props.isActive &&
    `
    &:after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      height: 2px;
      background-color: #33d6d4;
    }
  `}
`;

const TabsNavigation = ({ selectedTab: currentTab, setTab, tabs }) => (
  <NavigationBar>
    <Container>
      <TabPanel>
        {tabs.map(({ tab, title }, index) => (
          <TabButton
            key={index}
            isActive={tab === currentTab}
            onClick={() => {
              if (tab !== currentTab) {
                setTab(tab);
              }
            }}
          >
            {title}
          </TabButton>
        ))}
      </TabPanel>
    </Container>
  </NavigationBar>
);

export { TabsNavigation };
